export default __webpack_public_path__ + "static/media/logo.0f525a00.png";